import axios from 'axios';
import CardsHead from './ui/cards-head/cards-head';
import {debounce} from 'lodash';
import ElectorFilter from './ui/elector-filter/elector-filter';
import initFlatCard from '@/components/flat-card/flat-card';
import serialize from '@/common/scripts/serialize';
import templateFlatCard from '@/components/flat-card/flat-card.twig.js';

const CARDS_VIEW_TYPES = {
    GRID: 'grid',
    LIST: 'list'
};

const MAX_LOAD_CARDS = 8;

export const initElector = (parent: HTMLElement): void => {
    if (!parent) {
        console.error(`Parent is ${parent}`);
    }

    const parentSelector = 'elector';
    const selectors = {
        cards            : `${parentSelector}__cards`,
        btnLoadMore      : `${parentSelector}__btn-load-more`,
        btnLoadMoreHidded: `${parentSelector}__btn-load-more--hidded`,
        btnFilter        : `${parentSelector}__btn-filter`,
        flatCard         : `${parentSelector}__flat-card`,
        electorFilter    : `${parentSelector}__elector-filter`,
        unfoundMsg       : `${parentSelector}__unfound-msg`,
        unfoundMsgHidded : `${parentSelector}__unfound-msg--hidded`,
        attrCardsView    : 'data-cards-view',
        attrTotal        : 'data-total'
    } as const;

    const cardsEl = parent.querySelector(`.${selectors.cards}`);
    const btnLoadMoreEl = parent.querySelector(`.${selectors.btnLoadMore}`);
    const flatCardsEl = parent.querySelectorAll('.elector__flat-card');
    const btnFilter = parent.querySelector(`.${selectors.btnFilter}`);
    const filterEl = parent.querySelector(`.${selectors.electorFilter}`) as HTMLElement;
    const unfoundMsgEl = parent.querySelector(`.${selectors.unfoundMsg}`) as HTMLElement;
    let totalCards = Number(cardsEl?.getAttribute(selectors.attrTotal)) || 0;
    let reqData: null | object = null;
    let reqAction = '';
    let currentFieldKeys: string[] = [];
    let quantityElCard: number = flatCardsEl.length ?? 0;

    const getLengthCards = (): number => {
        return [].slice.call(cardsEl?.querySelectorAll(`.${selectors.flatCard}`)).length;
    };

    const createInlineCards = (items: any[]): string => {
        if (!Array.isArray(items)) {
            return '';
        }

        return items.reduce((acc, item) => {
            return `${acc}${templateFlatCard({...item,
                class: selectors.flatCard})}`;
        }, '');
    };

    const changeViewUnfoundMsgByTotal = (total: number): void => {
        if (total > 0) {
            unfoundMsgEl.classList.add(selectors.unfoundMsgHidded);
        } else {
            unfoundMsgEl.classList.remove(selectors.unfoundMsgHidded);
        }
    };

    const changeViewBtnByTotal = (total?: number): void => {
        if ((total || totalCards) <= getLengthCards()) {
            btnLoadMoreEl?.classList.add(selectors.btnLoadMoreHidded);
        } else {
            btnLoadMoreEl?.classList.remove(selectors.btnLoadMoreHidded);
        }
    };

    const instCardsHead = new CardsHead(parent, {
        onChangeSort: () => {
            getNewDataByFilter({
                data  : reqData,
                action: reqAction
            });
        },
        onToggle: (type) => {
            if (type === CARDS_VIEW_TYPES.LIST) {
                cardsEl?.setAttribute(selectors.attrCardsView, CARDS_VIEW_TYPES.LIST);
            } else {
                cardsEl?.setAttribute(selectors.attrCardsView, CARDS_VIEW_TYPES.GRID);
            }
        }
    });

    const setUrlParams = (data: Record<string, any>): void => {
        const urlInst = new URL(window.location.href);

        currentFieldKeys.forEach((key) => {
            urlInst.searchParams.delete(key);
        });
        urlInst.search = serialize(data);

        history.pushState({}, '', urlInst.toString());
    };

    instCardsHead.updateSearchedCount(totalCards, flatCardsEl.length);

    const getNewDataByFilter = ({data, action}: { data: any, action: string }): void => {
        reqData = data;
        reqAction = action;
        const sortData = instCardsHead.currSort;
        const updatedData = {
            ...data,
            [sortData.name]: sortData.value
        };

        axios.get(action, {params: updatedData})
            .then((res) => {
                totalCards = res.data.total;
                quantityElCard = res.data.items.length;
                if (Array.isArray(res.data.items) && cardsEl) {
                    cardsEl.innerHTML = createInlineCards(res.data.items);
                    changeViewBtnByTotal(totalCards);
                }
                changeViewUnfoundMsgByTotal(res.data.total || 0);
                [].slice.call(parent.querySelectorAll('.elector__flat-card')).forEach((node: HTMLElement) => {
                    initFlatCard(node);
                });
                instCardsHead.updateSearchedCount(totalCards, quantityElCard);
                setUrlParams(updatedData);
                window.scrollTo({
                    top     : 0,
                    left    : 0,
                    behavior: 'smooth'
                });
            });
    };

    const instansFilter = new ElectorFilter(filterEl, {
        onInit: debounce(({data, action, keys}) => {
            reqData = data;
            reqAction = action;
            currentFieldKeys = keys;
        }, 100),
        onChange: debounce(({data, action}) => {
            getNewDataByFilter({
                data,
                action
            });
        },
        500)
    });

    if (flatCardsEl?.length) {
        flatCardsEl.forEach((el) => {
            initFlatCard(el as HTMLElement);
        });
    }


    if (btnLoadMoreEl) {
        btnLoadMoreEl.addEventListener('click', () => {
            if (!reqData) {
                return;
            }

            const sortData = instCardsHead.currSort;

            axios.get(reqAction, {params: {
                ...reqData,
                offset         : getLengthCards(),
                limit          : MAX_LOAD_CARDS,
                [sortData.name]: sortData.value
            }})
                .then((res) => {
                    const items = res.data.items || res.data || [];

                    if (Array.isArray(items) && items.length && cardsEl) {
                        cardsEl.insertAdjacentHTML('beforeend', createInlineCards(items));
                        [].slice.call(parent.querySelectorAll('.elector__flat-card')).forEach((node: HTMLElement) => {
                            initFlatCard(node);
                        });
                        quantityElCard = quantityElCard + items.length;
                        instCardsHead.updateSearchedCount(totalCards, quantityElCard);
                    }

                    changeViewBtnByTotal();
                });
        });
    }

    if (btnFilter) {
        btnFilter.addEventListener('click', () => {
            instansFilter.showFilter();
        });
    }
};
